import { render, staticRenderFns } from "./ModalCadastroQhPlano.vue?vue&type=template&id=5f2d1ad7"
import script from "./ModalCadastroQhPlano.vue?vue&type=script&lang=js"
export * from "./ModalCadastroQhPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports